import { render, staticRenderFns } from "./PastOrders.vue?vue&type=template&id=08734834"
import script from "./PastOrders.vue?vue&type=script&lang=ts"
export * from "./PastOrders.vue?vue&type=script&lang=ts"
import style0 from "./PastOrders.vue?vue&type=style&index=0&id=08734834&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports